import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBh = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	id: "flag-icons-bh",
	viewBox: "0 0 640 480",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "#fff",
		d: "M0 0h640v480H0"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "#ce1126",
		d: "M640 0H96l110.7 48L96 96l110.7 48L96 192l110.7 48L96 288l110.7 48L96 384l110.7 48L96 480h544"
	})]
});
export default SvgBh;
